// LoginPage.jsx
import React, { useState } from 'react';
import './cb.css'; // Riutilizziamo lo stesso CSS base
import { MessageSquareWarningIcon } from 'lucide-react';

import LANG from './lang'

import config, { getProfileFromToken } from './config'
import { useNavigate } from 'react-router-dom';

const LoginPage = ({handleLoginSuccess}) => {
    // Stato per la gestione dei campi
      
    const [email, setEmail] = useState('');
    const [currentLang, setLanguage] = useState('it');
    const [profilo, setProfilo] = useState('');
    const [code, setCode] = useState('');
    
  
    const [stage, setStage] = useState('email_input'); 
    
    const [error, setError] = useState('');

    const l = LANG(localStorage.getItem('appLanguage'));

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        if (code.length < 3) { 
            setError('Il codice deve essere di 3 caratteri almeno.');
            return;
        }
        setStage('logging_in');
        try{
        const formData = new FormData();
        formData.append("username", email);
        formData.append("password", code);
    
        const response = await fetch(config.apiUrl+"/token", {
            method: "POST",
            body: formData,
        });
        if (!response.ok){
            console.log("errore autenticazione");
                        setStage('email_input'); 
            return;
           
        }
        
        const data = await response.json();
        console.log("Token ricevuto:", data.access_token);  
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("email", email);
     
        console.log(response.body);
        
        setProfilo(getProfileFromToken())
        
        handleLoginSuccess(email,getProfileFromToken())
        }  catch (err) {
            console.log(err);
            alert("Errore di autenticazione controllare username e password.")
            setStage('email_input'); 
     
        }
     
    };
    

  const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
        localStorage.setItem('appLanguage', e.target.value)
    };
 
    const renderEmailInput = () => (
        <form onSubmit={handleLogin}>
            <div className="language-selector-container">
                    <label htmlFor="lang-select" className="text-sm font-medium"></label>
                    <select
                        id="lang-select"
                        value={currentLang} // Controllato dallo stato globale
                        onChange={handleLanguageChange} // Chiama la funzione per aggiornare lo stato globale
                        className="p-1 border rounded"
                    >
                        <option value="it">IT </option>
                        <option value="en">EN</option> 
                    </select>
                </div>
            <h2>{l.AUTH_TITLE_EMAIL}</h2>
            <p>{l.AUTH_DESC_EMAIL}</p>
            
            <input
                type="text"
                placeholder={l.AUTH_PLACEHOLDER_EMAIL}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="auth-input"
            />
        
            <input
                type="password"
                placeholder={l.AUTH_PLACEHOLDER_CODE}
                value={code}
                onChange={(e) => setCode(e.target.value)}
                //maxLength={166}
                required
                className="auth-input"
            />
            
            <button type="submit" className="auth-button">
                {l.AUTH_BTN_LOGIN}
                
                
            </button>
                {/*<img alt="l2og" width="20%" src="aimoxlogo.png"/> */}
            
        </form>
    );
    
    const renderLoading = () => (
        <div className="loading-state">
            <div className="spinner"></div> 
            <p>In corso, attendi...</p>
        </div>
    );

    // --- RENDER PRINCIPALE ---
    return (
        <div className="login-page-container">
            <div className="login-box">
                {/*
                <div className="auth-logo-filigrana">
                    <img alt="log" width="50%" src="aimoxlogo.png"/>
                </div>

                <h1 className="app-title">AI MOX</h1>
                */}
                
                <img alt="log" width="50%" src="aimoxicona.png"/><br/>
                
                {error && <div className="error-message"><MessageSquareWarningIcon/> {error}</div>}

                {stage === 'email_input' && renderEmailInput()}
                
                {stage === 'logging_in' && renderLoading()}
            </div>
        </div>
    );
};

export default LoginPage;